import { render, staticRenderFns } from "./loop-node.vue?vue&type=template&id=2cf02052&scoped=true"
import script from "./loop-node.vue?vue&type=script&lang=js"
export * from "./loop-node.vue?vue&type=script&lang=js"
import style0 from "./loop-node.vue?vue&type=style&index=0&id=2cf02052&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf02052",
  null
  
)

export default component.exports